import { render, staticRenderFns } from "./emailIndex.vue?vue&type=template&id=457876aa&"
import script from "./emailIndex.vue?vue&type=script&lang=js&"
export * from "./emailIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports